import {merge} from 'rxjs/observable/merge';

import DataService from "../../../../core/services/data-service/data-service";
import DatasetService from "../../../../core/services/datasetService";
import WidgetService from "../../../../core/services/widgetService";
import {TimeSeriesController} from "../timeSeriesController";
import TemplateParser from "../../../../core/utils/templateParser";

import RealTimeDataService from "../../../../core/services/data/realtimeDataService";
import SmashDataService from "../../../../core/services/data/dataService";
import TimerService from "../../../../core/services/data/timerService";

export class TradingViewApi extends TimeSeriesController {

  constructor({widget, updateCallback, togglePreloader, getResolutionInMillis}) {
    super(widget, updateCallback);
    this.legends = widget.legends;
    this.shouldSubscribe = true;
    this.realtimeCallbacks = {};
    this.mainSeriseData = [];
    this.getResolutionInMillis = getResolutionInMillis;
  }

  onReady(callback) {
    setTimeout(() => {
      callback({
        exchanges: [],
        symbols_types: [],
        supported_resolutions: [],
        supports_marks: true,
        supports_timescale_marks: true,
        supports_time: false
      })
    }, 0);
  }

  searchSymbols(userInput, exchange, symbolType, onResultReadyCallback) {
    DatasetService.getDataSetsByName(userInput)
      .then(datasets => {
        const symbols = this.toSymbols(datasets);
        onResultReadyCallback(symbols);
      })
  }

  resolveSymbol(symbolNameOrTicker, onSymbolResolvedCallback, onResolveErrorCallback) {
    const legend = this.legends.find(l => l.id === symbolNameOrTicker);
    const symbol = this.legendToSymbol(legend);
    setTimeout(() => {
      onSymbolResolvedCallback(symbol);
    });
  }

  getBars(symbolInfo, resolution, from, to, onHistoryCallback, onErrorCallback, firstDataRequest) {
    if (symbolInfo.ticker === "Loading") {
      onHistoryCallback([], {noData: true});
    } else {
      if (firstDataRequest) {
        const index = this.legends.findIndex(l => l.id === symbolInfo.ticker);
        const requests = WidgetService.getServerSideFunctionRequests({
          getLegends: () => this.legends
        });

        if (requests) {
          DataService.getServerSideFunctionResult(requests)
            .then(response => {
              const data = this.processingSnapshotData(response.result)[index];
              const bars = data
                .filter(d => d.y != null && d.time)
                .map(d => {
                  return {
                    time: d.time * 1000,
                    open: +d.y,
                    high: +d.y,
                    low: +d.y,
                    close: +d.y,
                    volume: 0
                  };
                });

              if (index === 0) {
                this.mainSeriseData = [...this.mainSeriseData, ...bars];
              }
              onHistoryCallback(bars, {noData: true});
            });
        } else {
          onHistoryCallback([], {noData: true});
        }
      } else {
        onHistoryCallback([], {noData: true});
      }
    }
  }

  subscribeBars(symbolInfo, resolution, onRealtimeCallback, subscriberUID) {
    // store callbacks
    this.realtimeCallbacks[symbolInfo.ticker] = onRealtimeCallback;

    if (this.shouldSubscribe) {

      const resolutionInMillis = this.getResolutionInMillis();
      this.realtimeSubscriptions = RealTimeDataService.subscribeRealtimeDataFromLegneds(this.legends);
      this.subscriberUID = subscriberUID;
      this.shouldSubscribe = false;
      let streams = [];

      // request interval in order to update chart consistently even if there is no update from the server
      if (resolutionInMillis > 0) {
        const interval = TimerService.registerInterval(subscriberUID, resolutionInMillis);
        streams = [interval];
      }

      streams = [...streams, ...this.realtimeSubscriptions.map(s => s.dataStream)];

      merge(...streams)
        .subscribe(_ => {
          // widget specific data handling logic
          this.legends.forEach(l => {
            const data = SmashDataService.processData(l);
            if (data && this.realtimeCallbacks[l.id]) {
              if (data.y != null && !isNaN(data.y)) {
                const currentTimePeriod = Math.ceil(new Date().getTime() / resolutionInMillis) * resolutionInMillis;
                if (typeof _ !== "number") {
                  console.log(`current time: ${new Date().toString()}   current time bucket: ${new Date(currentTimePeriod).toString()}   value: ${data.y}`)
                } else {
                  console.log('time elapsed update: ' + new Date().getTime() + '  val: ' + data.y);
                }
                this.realtimeCallbacks[l.id]({
                  time: Math.ceil(new Date().getTime() / resolutionInMillis) * resolutionInMillis,
                  open: data.y,
                  high: data.y,
                  low: data.y,
                  close: data.y,
                  volume: 0
                });
              }
            }
          });
        })
    }
  }

  unsubscribeBars(subscriberUID) {

  }

  destory() {
    TimerService.deregisterInterval(this.subscriberUID);
    if (this.realtimeSubscriptions) {
      RealTimeDataService.unsubscribeAll(this.realtimeSubscriptions);
    }
  }

  calculateHistoryDepth(resolution, resolutionBack, intervalBack) {
  }

  getMarks(symbolInfo, startDate, endDate, onDataCallback, resolution) {
  }

  getTimescaleMarks(symbolInfo, startDate, endDate, onDataCallback, resolution) {
  }

  getServerTime(callback) {
    setTimeout(() => {
      const currentTime = parseInt(new Date().getTime() / 1000);
      callback(currentTime);
    }, 0);
  }

  toSymbols(datasets) {
    return datasets.map(d => this.toSymbol(d));
  }

  toSymbol(dataset) {
    if (dataset) {
      return {
        symbol: dataset.name,
        full_name: dataset.name,
        ticker: dataset.persistenceId,
        description: dataset.description,
        exchange: "",
        //              minmov: 1,
        //              pricescale: 1,
        session: "24x7",
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        // has_intraday: true
      }

    }
  }

  legendToSymbol(legend) {
    if (legend) {
      return {
        symbol: TemplateParser.parseTemplate(legend.parameters.legendLabel),
        name: TemplateParser.parseTemplate(legend.parameters.legendLabel),
        full_name: TemplateParser.parseTemplate(legend.parameters.legendLabel),
        ticker: legend.id,
        description: "",
        exchange: "",
        session: "24x7",
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        has_intraday: true,
        pricescale: 1000,
        minmov: 1
      }
    } else {
      return {
        symbol: "Loading",
        name: "Loading",
        full_name: "Loading",
        ticker: "Loading",
        description: "Loading",
        exchange: "",
        session: "24x7",
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        has_intraday: true,

      }
    }
  }

  getLegendById(id) {
    return this.legends.filter(l => l.id === id);
  }

  getMainSeriseDataRange() {
    let from, to;
    for (let i = 0; i < this.mainSeriseData.length; i++) {
      if (this.mainSeriseData[i] && this.mainSeriseData[i].time) {
        from = this.mainSeriseData[i].time;
        break;
      }
    }

    for (let j = this.mainSeriseData.length - 1; j >= 0; j--) {
      if (this.mainSeriseData[j] && this.mainSeriseData[j].time) {
        to = this.mainSeriseData[j].time;
        break;
      }
    }

    return {from: Math.round(from / 1000), to: Math.round(to / 1000)};
  }

  /**
   * Find two points to place Fibonacci indicators.
   * @param {from, to}  the current time range. unix time
   * @return {from, to} unix time
   */
  getFibRange({from, to}) {
    let fromIndex = this.mainSeriseData.findIndex(d => d && d.time >= from * 1000);
    let toIndex = this.mainSeriseData.findIndex(d => d && d.time >= to * 1000);

    if (fromIndex === -1) {
      fromIndex = 0
    }

    if (toIndex === -1) {
      toIndex = this.mainSeriseData.length - 1;
    }

    const fibRange = toIndex - fromIndex;

    if (fibRange > 1) {
      const padding = Math.floor(fibRange / 4);

      return {
        from: Math.round(this.mainSeriseData[fromIndex + padding].time / 1000),
        to: Math.round(this.mainSeriseData[toIndex - padding].time / 1000)
      }
    } else {
      null;
    }
  }
}








// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/trading-view/api.js